import { Component, HostListener, TemplateRef } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MessageService } from 'primeng/api'
import { FormControl, FormGroup } from '@angular/forms';
import { IApproval, IAppByRole } from 'src/app/_services/ApplicationServices/approval';
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
import { Router } from '@angular/router';
import { ApprovalService } from 'src/app/_services/ApplicationServices/approval.service';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { Subscription } from 'rxjs';
import { QuickDeligationService } from 'src/app/_services/ApplicationServices/quick-delegation.service';
import {formatDate } from '@angular/common';
import { IntegratedAppDetails } from 'src/app/_services/ApplicationServices/quick-delegation';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    providers: [MessageService],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX(100%)' }),
                animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
            ])
        ]),
        trigger('animateWdth', [
            transition(':enter', [
                style({ width: '0px' }),
                animate('200ms ease-in', style({ width: '140px' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ width: '0px' }))
            ])
        ])
    ],
    standalone: false
})
export class HomeComponent {
  rejectModal2: any;
  addClassToBody() {
    throw new Error('Method not implemented.');
  }
  visible: any;
  brand: any;
  showDialog() {
    throw new Error('Method not implemented.');
  }

  responsiveOptions: any[] | undefined;
  productService: any;


  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };


  SapId: string;
  EmployeeName: string;
  EmployeeSubGroup: string;
  OnBehalf: boolean = false;
  Designation: string;
  getpending: Subscription;
  getRequest: Subscription;
  public showContent: boolean = false;
  subscriptionPendingRequest: Subscription;
  subscriptionRoleByPending: Subscription;
  subScriptionMyRequests: Subscription;
  subScriptionRoleByRequest: Subscription;
  subScriptionDocumentNameDetails: Subscription;
  employeeId: string;
  deploymentTime: number = Date.now();
  pendingRequests: IApproval[];
  filteredPendingRequests: IApproval[];
  topFivePendingRequestData: IApproval[];
  topFiveMyRequestData: IApproval[];
  myRequests: IApproval[];
  filteredMyRequests: IApproval[];
  roleByAppSlider: IAppByRole[];
  roleByAppSlierApprovalLength;
  roleByAppSliderMyRequest: IAppByRole[];
  roleByAppSliderLength;
  application;
  Role;
  mypendingApplication;
  mypendingRole;
  totalRows: number;
  totalRequestRows: number;
  errorMessage: string;
  _filterMyRequest: string;
  _listFilter: string;
  _requestId: string = null;
  _applicationList: string = null;
  _roleName: string = null;
  appddldata: IApproval[];
  roleddldata: IApproval[];
  _pendingrequestId: string = null;
  _pendingRoleName: string = null;
  _pendingapplicationList: string = null;
  delReqId: number;
  hiddenBtn: boolean = true;
  today= new Date();
  todaysDataTime = '';
  
  nowtime =  formatDate(this.today, 'hh:mm', 'en-US', '+0530'); //Date.now().toString();
  aftertime = formatDate(this.today, 'hh:mm', 'en-US', '+0540');


  ngOnInit() {
    this.QuickDesignation();
    this.loginService.getEmployeeId();
    if (!this.loginService.isloginPage || localStorage.getItem('isLoggedInDelegated') == "false") {
      this.loginService.getAuthenticationInfo(localStorage.getItem('UserName')).subscribe((resFromProfile) => {
        // localStorage.setItem("Role", resFromProfile.Data[0].EMDesig);
        // localStorage.setItem('SapId', resFromProfile.Data[0].EMEmpCode);
        // sessionStorage.setItem('SapId', resFromProfile.Data[0].EMEmpCode);
        // localStorage.setItem('EmpName', resFromProfile.Data[0].EmpName);
        this.EmployeeName = resFromProfile.Data[0].EmpName;
        this.EmployeeSubGroup = resFromProfile.Data[0].EMEmpSubgroup;
        this.Designation = resFromProfile.Data[0].EMDesig;
        this.OnBehalf = resFromProfile.Data[0].ADVDelFlag;
        this.SapId = resFromProfile.Data[0].EMEmpCode;
        this.loginService.isRefreshed = true;
        //store  SAPID with login ID use the API calling
        this.global.UserLoggedInSAPID = resFromProfile.Data[0].EMEmpCode;
        this.GetMyApprovalData();
        this.GetMyRequestData();
        this.subscriptionRoleByPending = this.approvalService.getPendingRoleByAppSlider().subscribe(
          {
            next: roleByApp => {
              this.roleByAppSlider = roleByApp;
              this.roleByAppSlierApprovalLength = roleByApp.length;
            }
          });
        this.subScriptionRoleByRequest = this.approvalService.getRoleByAppSliderMyRequest().subscribe(
          {
            next: roleByAppMyRequest => {
              this.roleByAppSliderMyRequest = roleByAppMyRequest;
              this.roleByAppSliderLength = roleByAppMyRequest.length;
            },
            error: err => this.errorMessage = err
          });
      });

    }
    else {
      this.GetMyApprovalData();
      this.GetMyRequestData();
      this.subscriptionRoleByPending = this.approvalService.getPendingRoleByAppSlider().subscribe(
        {
          next: roleByApp => {
            this.roleByAppSlider = roleByApp;
            this.roleByAppSlierApprovalLength = roleByApp.length;
          }
        });
      this.subScriptionRoleByRequest = this.approvalService.getRoleByAppSliderMyRequest().subscribe(
        {
          next: roleByAppMyRequest => {
            this.roleByAppSliderMyRequest = roleByAppMyRequest;
            this.roleByAppSliderLength = roleByAppMyRequest.length;
          },
          error: err => this.errorMessage = err
        });
    }
    // this.productService.getProductsSmall().then((products) => {
    //     this.products = products;
    // });

    // this.responsiveOptions = [
    //     {
    //         breakpoint: '1199px',
    //         numVisible: 1,
    //         numScroll: 1
    //     },
    //     {
    //         breakpoint: '991px',
    //         numVisible: 2,
    //         numScroll: 1
    //     },
    //     {
    //         breakpoint: '767px',
    //         numVisible: 1,
    //         numScroll: 1
    //     }
    // ];
  }
  mailerData: any;
  GetMyApprovalData() {
    this.approvalService.getPendingRequests().subscribe(
      {
        next: requests => {
          this.pendingRequests = requests;
          this.filteredPendingRequests = requests;
          this.topFivePendingRequestData = requests.slice(0, 5);
          this.totalRows = this.filteredPendingRequests.length;
          if (requests.length > 0) {
            this.hiddenBtn = false;
          }
          var mypendingapplications = [];
          var mypendingappText = [];
          var mypendingappVal = [];
          mypendingapplications = [{ label: 'Select', value: null }];
          mypendingappVal = this.filteredPendingRequests.map(a => a.AppId).filter((value, index, self) => self.indexOf(value) === index);
          mypendingappText = this.filteredPendingRequests.map(a => a.ApplicationCode).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < mypendingappVal.length; i++) {
            mypendingapplications.push({ label: mypendingappText[i], value: mypendingappVal[i] });
          }
          this.mypendingApplication = mypendingapplications;
          var mypendingroles = [];
          var mypendingroleName = [];
          var mypendingroleVal = [];
          mypendingroles = [{ label: 'Select', value: null }];
          mypendingroleVal = this.filteredPendingRequests.map(a => a.RoleId).filter((value, index, self) => self.indexOf(value) === index);
          mypendingroleName = this.filteredPendingRequests.map(a => a.RoleName).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < mypendingroleVal.length; i++) {
            mypendingroles.push({ label: mypendingroleName[i], value: mypendingroleVal[i] });
          }
          this.mypendingRole = mypendingroles;
        },
        error: err => this.errorMessage = err
      });
  }
  GetMyRequestData() {

    this.subScriptionMyRequests = this.approvalService.getMyRequest().subscribe(
      {

        next: requestsList => {
          this.myRequests = requestsList;
          this.topFiveMyRequestData = requestsList.slice(0, 6);
          this.filteredMyRequests = requestsList;
          this.totalRequestRows = this.filteredMyRequests.length;
          var applications = [];
          var appText = [];
          var appVal = [];
          applications = [{ label: 'Select', value: null }];
          appVal = this.filteredMyRequests.map(a => a.AppId).filter((value, index, self) => self.indexOf(value) === index);
          appText = this.filteredMyRequests.map(a => a.ApplicationCode).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < appVal.length; i++) {
            applications.push({ label: appText[i], value: appVal[i] });
          }
          this.application = applications;

          var roles = [];
          var roleName = [];
          var roleVal = [];
          roles = [{ label: 'Select', value: null }];
          roleVal = this.filteredMyRequests.map(a => a.RoleId).filter((value, index, self) => self.indexOf(value) === index);
          roleName = this.filteredMyRequests.map(a => a.RoleName).filter((value, index, self) => self.indexOf(value) === index);
          for (var i = 0; i < roleVal.length; i++) {
            roles.push({ label: roleName[i], value: roleName[i] });
          }
          this.Role = roles;
        },
        error: err => this.errorMessage = err
      });
    this.showContent = true;
  }
  calcluateDateDiff(endDateIn, startDateIn) {
    let startDate = new Date(startDateIn);
    let endDate = new Date(endDateIn);
    return Math.floor((Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) - Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())) / (1000 * 60 * 60 * 24))
  }


  getSeverity(status: string) {
    switch (status) {
      case 'INSTOCK':
        return 'success';
      case 'LOWSTOCK':
        return 'warning';
      case 'OUTOFSTOCK':
        return 'danger';
    }
  }





  visibleSidebar2: any;

  itemsPerSlide = 4;
  singleSlideOffset = false;
  noWrap = false;



  //  Search
  search = false
  hideBtn = true
  openSearch(event) {
    event.stopPropagation();
    this.search = !this.search
    this.hideBtn = !this.hideBtn
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.search = false
    this.hideBtn = true
  }

  // Textclear
  serachT;
  textClear(event) {
    event.stopPropagation();
    this.serachT = ""
  }

  /* MODAL */
  modalRef: BsModalRef;
  // success
  sucImg = "assets/images/tick.gif";

  // Active
  selectedIndex: number = 0;
  subModules = [{ name: "1 Month" }, { name: "3 Months" }, { name: "6 Months" }, { name: "1 Year" }]

  setIndex(index: number) {
    this.selectedIndex = index;

  }


  // textarea
  maxChars = 500;
  role = '';
  chars = 0;

  // View Card
  viewLess = false
  viewAll
  viewll() {
    this.viewAll = !this.viewAll
    this.viewLess = !this.viewLess
  }

  viewll2
  viewllCard() {
    this.viewll2 = !this.viewll2

  }

  //  Select all CheckBox
  mast = false;
  child1 = false
  child2 = false
  child3 = false
  child4 = false
  child5 = false
  master() {
    this.mast = this.mast;
    if (this.mast === true) {
      this.child1 = true
      this.child2 = true
      this.child3 = true
      this.child4 = true
      this.child5 = true
    }
    if (this.mast === false) {
      this.child1 = false
      this.child2 = false
      this.child3 = false
      this.child4 = false
      this.child5 = false
    }
  }

  child() {
    if (this.child1 === true && this.child2 === true && this.child3 === true && this.child4 === true) {
      this.mast = true;
    }
    else {
      this.mast = false;
    }
  }
  // CheckBox end

  // Dropdwon
  option1
  constructor(private global: GlobalService,private modalService: BsModalService, private messageService: MessageService, private loginService: LoginService, private appInsights: AppInsightsService,
    private router: Router, private approvalService: ApprovalService,private quickDelService: QuickDeligationService) {
    this.option1 = [
      { label: 'Select', value: null },
      { label: 'Option 1', value: { id: 1, name: 'Option1', code: 'O1' } },
      { label: 'Option 2', value: { id: 2, name: 'Option2', code: 'O4' } },
      { label: 'Option 3', value: { id: 3, name: 'Option3', code: 'O3' } },
      { label: 'Option 4', value: { id: 4, name: 'Option4', code: 'O4' } },
      { label: 'Option 5', value: { id: 5, name: 'Option5', code: 'O5' } }
    ];
  }




  brands: string[] = [
    'Pawan Gupta (401267)',
    'Pawan Chobe (4016567)',
    'Pawan Misra (40126567)',
    'Pawan  Singh (26540167)',
    'Deivasigamani Tamilselvam (51897560)',
    'Anupama Parameswaran (40387651)'
  ];
  filteredBrands: any[];
  filterBrands(event) {
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      let brand = this.brands[i];
      if (brand.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
        this.filteredBrands.push(brand);
      }
    }
  }




  openModal(approvedModal: TemplateRef<void>) {
    this.modalRef = this.modalService.show(approvedModal, this.config);
    document.body.classList.add('modal-open2');
  }
  hideSuccessMsg() {
    document.body.classList.remove('modal-open2');
  }

  ListQuickDesignation:IntegratedAppDetails[];
  QuickDesignation() {
    this.quickDelService.GetActiveApplications().subscribe(res => {
      this.ListQuickDesignation = res;
      localStorage.removeItem('services_assigned');
      localStorage.setItem('services_assigned', JSON.stringify(this.ListQuickDesignation));
    });
  } 

}





